import BaseService from "../../../common/services/src/baseService";

const _policy = [
	{
		regex: /^(?=.*).{8,}$/,
		weight: 1
	},
	{
		regex: /\d/,
		weight: 1
	},
	{
		regex: /^(?=.*[A-Z]).*$/,
		weight: 1
	},
	{
		regex: /^(?=.*[a-z]).*$/,
		weight: 1
	},
	{
		regex: /^(?=.*[\W]).*$/,
		weight: 1
	}
];


const _states = [
	{
		color: '#F00',
		msg: 'Weak'
	},
	{
		color: '#F00',
		msg: 'Weak'
	},
	{
		color: '#F00',
		msg: 'Weak'
	},
	{
		color: '#F00',
		msg: 'Weak'
	},
	{
		color: '#09AA4C',
		msg: 'Strong'
	}
];

var _isStrong = false;
var _weight = 0;

class PasswordStrengthService  extends BaseService {

	constructor() {
		super("com.jacada.common.services.login.PasswordStrengthService");
	}

	setPassword(password) {
		_weight = 0;
		for (var p in _policy) {
			if (_policy[p].regex.test(password)) {
				_weight = _weight + _policy[p].weight;
			}
		}
		_isStrong = _weight === 5;
	}

	getWeight() {
		return _weight;
	}

	getState() {
		var state = {};
		state.color = _states[_weight-1].color;
		state.msg = _states[_weight-1].msg;
		return state;
	}

	getNumberOfStates() {
		return _weight;
	}
}

export default new PasswordStrengthService();




// WEBPACK FOOTER //
// ./src/services/PasswordStrengthService.js